module.exports = __webpack_public_path__ + "static/media/C_E03.de4b50a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_E03.png
// module id = 71
// module chunks = 0